const testimonialsSlider = () => {
  import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
    $(".js-testimonial-slider").slick({
      arrows: true,
      dots: false,
      infinite: true,
      autoplay: false,
      prevArrow: '<button type="button" class="slick-arrow slick-prev"><span class="svg-container icon"><svg height="25.03" viewBox="0 0 15 25.03" width="15" xmlns="http://www.w3.org/2000/svg"><path d="m263.11 1966.01a1.916 1.916 0 0 1 1.324.53 1.722 1.722 0 0 1 0 2.52l-9.912 9.45 9.912 9.44a1.734 1.734 0 0 1 0 2.53 1.952 1.952 0 0 1 -2.648 0l-11.236-10.71a1.732 1.732 0 0 1 0-2.53l11.236-10.7a1.914 1.914 0 0 1 1.324-.53z" fill="#c5c5c5" fill-rule="evenodd" transform="translate(-250 -1966)"/></svg></span></button>',
      nextArrow: '<button type="button" class="slick-arrow slick-next"><span class="svg-container icon"><svg height="25" viewBox="0 0 14.97 25" width="14.97" xmlns="http://www.w3.org/2000/svg"><path d="m1236.89 1966.01a1.93 1.93 0 0 0 -1.32.52 1.719 1.719 0 0 0 0 2.53l9.91 9.43-9.91 9.44a1.708 1.708 0 0 0 0 2.52 1.942 1.942 0 0 0 2.64 0l11.24-10.7a1.718 1.718 0 0 0 0-2.52l-11.24-10.7a1.93 1.93 0 0 0 -1.32-.52z" fill="#c5c5c5" fill-rule="evenodd" transform="translate(-1235.03 -1966)"/></svg></span></button>',
      autoplaySpeed: 5000,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            dots: true,
          }
        }
      ],
    });
  });
}

const packagesSlider = () => {
  import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
    $(".js-packages-slider").slick({
      arrows: true,
      dots: false,
      infinite: true,
      autoplay: false,
      prevArrow: '<button type="button" class="slick-arrow slick-prev"><span class="svg-container icon"><svg height="25.03" viewBox="0 0 15 25.03" width="15" xmlns="http://www.w3.org/2000/svg"><path d="m263.11 1966.01a1.916 1.916 0 0 1 1.324.53 1.722 1.722 0 0 1 0 2.52l-9.912 9.45 9.912 9.44a1.734 1.734 0 0 1 0 2.53 1.952 1.952 0 0 1 -2.648 0l-11.236-10.71a1.732 1.732 0 0 1 0-2.53l11.236-10.7a1.914 1.914 0 0 1 1.324-.53z" fill="#c5c5c5" fill-rule="evenodd" transform="translate(-250 -1966)"/></svg></span></button>',
      nextArrow: '<button type="button" class="slick-arrow slick-next"><span class="svg-container icon"><svg height="25" viewBox="0 0 14.97 25" width="14.97" xmlns="http://www.w3.org/2000/svg"><path d="m1236.89 1966.01a1.93 1.93 0 0 0 -1.32.52 1.719 1.719 0 0 0 0 2.53l9.91 9.43-9.91 9.44a1.708 1.708 0 0 0 0 2.52 1.942 1.942 0 0 0 2.64 0l11.24-10.7a1.718 1.718 0 0 0 0-2.52l-11.24-10.7a1.93 1.93 0 0 0 -1.32-.52z" fill="#c5c5c5" fill-rule="evenodd" transform="translate(-1235.03 -1966)"/></svg></span></button>',
      autoplaySpeed: 5000,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            dots: true,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            arrows: false,
            dots: true,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            arrows: false,
            dots: true,
          }
        }
      ],
    });
  });
}

const servicesSlider = () => {
  import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
    $(".js-services-slider").on('afterChange init', (event, slick) => {
        slick.$slides.removeClass('prevSlide').removeClass('nextSlide');
        for (let i = 0; i < slick.$slides.length; i += 1) {
          const $slide = $(slick.$slides[i]);
          if ($slide.hasClass('slick-current')) {
            $slide.prev().addClass('prevSlide');
            $slide.next().addClass('nextSlide');
            break;
          }
        }
      }
    ).on('beforeChange', (event, slick) => {
      slick.$slides.removeClass('prevSlide').removeClass('nextSlide');
    }).slick({
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slick-arrow slick-prev"><span class="svg-container icon"><svg height="25.03" viewBox="0 0 15 25.03" width="15" xmlns="http://www.w3.org/2000/svg"><path d="m263.11 1966.01a1.916 1.916 0 0 1 1.324.53 1.722 1.722 0 0 1 0 2.52l-9.912 9.45 9.912 9.44a1.734 1.734 0 0 1 0 2.53 1.952 1.952 0 0 1 -2.648 0l-11.236-10.71a1.732 1.732 0 0 1 0-2.53l11.236-10.7a1.914 1.914 0 0 1 1.324-.53z" fill="#c5c5c5" fill-rule="evenodd" transform="translate(-250 -1966)"/></svg></span></button>',
      nextArrow: '<button type="button" class="slick-arrow slick-next"><span class="svg-container icon"><svg height="25" viewBox="0 0 14.97 25" width="14.97" xmlns="http://www.w3.org/2000/svg"><path d="m1236.89 1966.01a1.93 1.93 0 0 0 -1.32.52 1.719 1.719 0 0 0 0 2.53l9.91 9.43-9.91 9.44a1.708 1.708 0 0 0 0 2.52 1.942 1.942 0 0 0 2.64 0l11.24-10.7a1.718 1.718 0 0 0 0-2.52l-11.24-10.7a1.93 1.93 0 0 0 -1.32-.52z" fill="#c5c5c5" fill-rule="evenodd" transform="translate(-1235.03 -1966)"/></svg></span></button>',
      centerMode: true,
      infinite: false,
      initialSlide: 1,
      centerPadding: '8%',
    });
  });
}

export { testimonialsSlider, packagesSlider, servicesSlider }
